<template>
   <div class="cadre">
    <h3>Fournisseur</h3>
        <table>
            <thead>
                <tr>
                    <th>Libellé</th>
                    <th>
                        <div class="tab_outils">
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditFournisseur"
                                    v-on:click="editFournisseur(null)">
                                    <i class="material-icons"
                                        style="font-size:20px;color:black; display: flex;justify-content: flex-end">add_circle</i>
                                </a>
                            </div>
                        </div>
                    </th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="(fournisseur, index) in fournisseurs" :key="fournisseur.id">
                    <td>{{ fournisseur.libelle }}</td>
                    <td>
                        <div class="tab_outils">
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditFournisseur"
                                v-on:click="editFournisseur(fournisseur.id)">
                                    <i class="material-icons" style="font-size:20px;color:black">edit</i>
                                </a>
                            </div>
                            <div>
                                <a v-on:click="deleteFournisseur(index)">
                                    <i class="material-icons" style="font-size:20px;color:red">delete</i>
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <FournisseurEdit :params="{ id: fournisseurId }" @saved="fetchFournisseur" />

</template>

<script>
import Axios from '@/services/axios.service';
import FournisseurEdit from './FournisseurEdit.vue';


export default {
    name: 'FournisseurIndex',
    components: {
        FournisseurEdit,
    },
    data() {
        return {
            fournisseurs: [],
            fournisseurId: null,
        };
    },
    props: {
        msg: String
    },
    mounted() {
        this.fetchFournisseur();
    },
    methods: {
        fetchFournisseur() {
            Axios.get('/fournisseur/statut/ACTIF')
                .then(res => {
                    this.fournisseurs = res.data;
                })
                .catch(err => {
                    console.error('Erreur lors du chargement des fournisseurs :', err);
                });
        },
        deleteFournisseur(index) {
            Axios.delete('/fournisseur/' + this.fournisseurs[index].id)
                .then(response => {
                    if (response.status == 200) {
                        this.fournisseurs.splice(index, 1)
                    }
                })
                .catch(err => {
                    alert(err)
                })
        },
        editFournisseur(id) {
            this.fournisseurId = id;

        },
    }
}
</script>

<style></style>